import { createWithEqualityFn } from 'zustand/traditional'
import { persist, devtools } from 'zustand/middleware'

export type chainType = 'bnb' | 'polygon' | 'ethereum' | 'multiversx'
export type networkType = 'testnet' | 'mainnet'

interface ChainAndNetworkState {
  chain: chainType
  network: networkType
  setChain: (chain: chainType) => void
  setNetwork: (network: networkType) => void
}

export const useChainAndNetwork = createWithEqualityFn<ChainAndNetworkState>()(
  devtools(
    persist(
      (set) => ({
        chain: 'multiversx',
        network: 'testnet',
        setChain: (newChain: chainType) => set(() => ({ chain: newChain })),
        setNetwork: (newNetwork: networkType) => set(() => ({ network: newNetwork })),
      }),
      {
        name: 'chain-network-storage',
      },
    ),
  ),
  Object.is,
)
